import DownloadIcon from "@mui/icons-material/GetApp";
import {
  Box,
  CircularProgress,
  Grid,
  Link,
  LinearProgress,
  List,
  ListItem,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import dayjs from "dayjs";
import * as React from "react";
import { useEffect, useState } from "react";
import { Button, useRefresh } from "react-admin";
import sendRequest from "../../dataProvider/sendRequest";
import CustomButtonCancel from "../../unit/CustomButtonCancel";
import CustomButtonSubmit from "../../unit/CustomButtonSubmit";
import CustomDateTextInput from "../../unit/CustomDateTextInput";
import CustomDialogTitle from "../../unit/CustomDialogTitle";
import downloadFileFun from "../../unit/DownloadFileFun";
import HeaderLabelTitle from "../../unit/HeaderLabelTitle";
import CustomControlEditTextField from "../../unit/forms/CustomControlEditTextField";
import CustomControlMoneyEditTextField from "../../unit/forms/CustomControlMoneyEditTextField";
import CustomEditControlSelect from "../../unit/forms/CustomEditControlSelect";
import CustomSelect from "../../unit/forms/CustomSelect";
import useNotify from "../../unit/useNotify";
import DialogApplicationBaseInfo from "../DialogApplicationBaseInfo";
import CustomToNotifyDepositDialog from "./CustomToNotifyDepositDialog";
import CustomToNotifyDisbursementDialog from "./CustomToNotifyDisbursementDialog";
import CustomToNotifyVendorDialog from "./CustomToNotifyVendorDialog";
import CustomApplicationDialogTitle from "./CustomApplicationDialogTitle";
import CustomToNotifyCollateralDialog from "./CustomToNotifyCollateralDialog";
import CustomButtonSave from "../../unit/CustomButtonSave";
import CustomButtonSaveMove from "../../unit/CustomButtonSaveMove";
import DownloadFieldLink from "../../unit/DownloadFieldLink";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  sx?: any;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, sx, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3, ...sx }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function CustomToNotify2ApprovedFormDialog({ ...props }) {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const [open, setOpen] = React.useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const { appId, record } = props;
  const [disabledTab, setDisabledTab] = useState(false);
  // 用于同步props.record变化到state
  useEffect(() => {
    // 只在Dialog已打开时同步，防止未打开时不必要的赋值
    if (!open) return;
    // 这里同步所有和Terms Tab相关的state
    setLateFee(
      record?.sSaved === "YES"
        ? record?.loan_saved_iLateFee
        : record?.defaultLateFee
    );
    setGracePeriodDay(
      record?.sSaved === "YES"
        ? record?.loan_saved_iGracePeriod
        : record?.iGracePeriod
    );
    setOriginationFeeAmount(
      record?.sSaved === "YES"
        ? record?.loan_saved_iOriginationFee
        : record?.origination_fee_amount || 0
    );
    setPaymentCount(record?.loan?.paymentsNumber);
    setNoteDate(record?.dNoteDate);
    setFirstPaymentDate(record?.dFirstPaymentDate);
    setPaymentFrequency(record?.sPaymentFrequency);
    setSPaymentRounding(record?.sPaymentRounding);
    setOrigination_fee_type(record?.origination_fee_type);
    let defaultRate = record?.rateRecommendation;
    if (record?.loan && record?.loan?.interestRate) {
      defaultRate = record?.loan?.interestRate;
    }
    if (defaultRate == "0.00") {
      defaultRate = 0;
    }
    setInterestRate(
      record?.sSaved === "YES" ? record?.loan_saved_iRate : defaultRate
    );
    let defaultTerm = record?.termSubmit;
    if (record?.termRecommendation) {
      defaultTerm = record?.termRecommendation;
    }
    if (record?.termReview) {
      defaultTerm = record?.termReview;
    }
    setTerms(parseInt(defaultTerm));
    setMaturityDate(record?.dMaturityDate);
  }, [record, open]);
  const setting = record?.setting;
  const max_latefee = setting?.max_latefee;
  const max_grace_period = setting?.max_graceperiod;
  const adjust_latefee = setting?.latefee_adjust;
  const adjust_grace_period = setting?.grace_period_adjust;
  const min_amount = setting?.minAmount;
  const max_amount = setting?.maxAmount;
  const cbfun = props?.cb;
  const loan_saved = record?.sSaved;
  console.log("loan_saved====>>>", loan_saved);
  const loan_saved_iOriginationFee = record?.loan_saved_iOriginationFee; //ok
  const loan_saved_origination_fee_type = record?.origination_fee_type; //ok
  let loan_saved_iRate = record?.loan_saved_iRate; //ok
  if (
    loan_saved_iRate == null ||
    loan_saved_iRate == undefined ||
    loan_saved_iRate == "" ||
    loan_saved_iRate == "0.00"
  ) {
    loan_saved_iRate = 0;
  }
  const loan_saved_iGracePeriod = record?.loan_saved_iGracePeriod; //ok
  const loan_saved_iLateFee = record?.loan_saved_iLateFee; //ok
  let loan_saved_loanamount = record?.iLoanAmount;
  if (loan_saved_origination_fee_type == "Deduct from Funded Amount") {
    loan_saved_loanamount = record?.iLoanAmount;
  } else {
    loan_saved_loanamount = record?.iFundAmount;
  }
  const termsDefineApprove = record?.termsDefine.notify_approve;
  // const [lateFee, setLateFee] = useState(record?.defaultLateFee);
  console.log("loan_saved_iLateFee===>", loan_saved_iLateFee);
  const [lateFee, setLateFee] = useState(
    loan_saved == "YES" ? loan_saved_iLateFee : record?.defaultLateFee
  );
  const [value, setValue] = React.useState(0);
  const [isSubmit, setIsSubmit] = useState(false);
  const [checkCal, setCheckCal] = useState(true);
  const [previewTitle, setPreviewTitle] = useState("Preview");
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [previewProgress, setPreviewProgress] = useState(0);
  const [previewProgressLabel, setPreviewProgressLabel] = useState("");
  const previewProgressRef = React.useRef(0);
  const approveFormRef = React.useRef<HTMLFormElement | null>(null);
  const generateProgressTimerRef = React.useRef<ReturnType<
    typeof setInterval
  > | null>(null);
  const downloadStartProgressRef = React.useRef(25);
  const [submitTitle, setSubmitTitle] = React.useState("Approve");
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [filePath, setFilePath] = React.useState("");
  const [generateFileInfo, setGenerateFileInfo] = useState<{
    filename: string;
    filetype: string;
    filekey: string;
    filelink?: string;
    docId: number;
  } | null>(null);
  // const [gracePeriodDay, setGracePeriodDay] = useState(record?.iGracePeriod);
  const [gracePeriodDay, setGracePeriodDay] = useState(
    loan_saved == "YES" ? loan_saved_iGracePeriod : record?.iGracePeriod
  );
  const [maturityDate, setMaturityDate] = useState(record?.dMaturityDate);
  // const [originationFeeAmount, setOriginationFeeAmount] = useState(
  //   record?.origination_fee_amount || 0
  // );
  const [originationFeeAmount, setOriginationFeeAmount] = useState(
    loan_saved == "YES"
      ? loan_saved_iOriginationFee
      : record?.origination_fee_amount || 0
  );
  const [paymentCount, setPaymentCount] = useState(
    record?.loan?.paymentsNumber
  );
  const [saveGeneralInfoTitle, setSaveGeneralInfoTitle] = useState("Save");
  // console.log("======================>", termsDefineApprove);
  const refresh = useRefresh();
  if (record?.dNoteDate == "0000-00-00 00:00:00") {
    record.dNoteDate = dayjs().format("YYYY-MM-DD");
  }
  const [noteDate, setNoteDate] = useState(record.dNoteDate);
  if (
    record?.dFirstPaymentDate == "0000-00-00 00:00:00" ||
    dayjs(record?.dFirstPaymentDate).isBefore(dayjs(), "day")
  ) {
    record.dFirstPaymentDate = dayjs().format("YYYY-MM-DD");
  }
  const [firstPaymentDate, setFirstPaymentDate] = useState(
    record.dFirstPaymentDate
  );

  const [paymentFrequency, setPaymentFrequency] = useState(
    record?.sPaymentFrequency
  );
  const [sPaymentRounding, setSPaymentRounding] = useState(
    record?.sPaymentRounding
  );
  const [origination_fee_type, setOrigination_fee_type] = useState(
    record?.origination_fee_type
  );
  let defaultRate = record?.rateRecommendation;
  if (record?.loan && record?.loan?.interestRate) {
    defaultRate = record?.loan?.interestRate;
  }
  if (defaultRate == "0.00") {
    defaultRate = 0;
  }
  // const [interestRate, setInterestRate] = useState(defaultRate);
  const [interestRate, setInterestRate] = useState(
    loan_saved == "YES" ? loan_saved_iRate : defaultRate
  );
  console.log(
    "defaultRate===>",
    defaultRate,
    "loan_saved_iRate===>",
    loan_saved_iRate,
    "interestRate===>",
    interestRate
  );
  let defaultTerm = record?.termSubmit;
  if (record?.termRecommendation) {
    defaultTerm = record?.termRecommendation;
  }
  if (record?.termReview) {
    defaultTerm = record?.termReview;
  }
  // if (record?.loan && record?.loan?.noteTerm) {
  //   defaultTerm = record?.loan?.noteTerm;
  // }
  const [terms, setTerms] = useState(parseInt(defaultTerm));

  const [submitFormData, setSubmitFormData] = useState({});

  const handleInputChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.target;
    // loanamount变化时，自动计算originationFeeAmount
    if (name === "loanamount") {
      let newOriginAmount = 0;
      if (
        value !== "" &&
        value !== null &&
        value !== undefined &&
        record?.iOriginationFee
      ) {
        if (record?.sOriginationFeeUnit === "Percentage") {
          newOriginAmount =
            (parseFloat(value.replace(/,/g, "")) * record.iOriginationFee) /
            100;
        } else if (record?.sOriginationFeeUnit === "Fixed") {
          newOriginAmount = record.iOriginationFee;
        }
      }
      setOriginationFeeAmount(newOriginAmount);
      setSubmitFormData({
        ...submitFormData,
        [name]: value,
        origination_fee_amount: newOriginAmount,
      });
      return;
    }
    setSubmitFormData({
      ...submitFormData,
      [name]: value,
    });
    //handleSaveInfoApprove({ event, appId });
  };
  const handleInputCustomChange = (
    p0: string,
    {
      name,
      value,
    }: {
      name: string;
      value: any;
    }
  ) => {
    setSubmitFormData({
      ...submitFormData,
      [name]: value,
    });
  };

  useEffect(() => {
    console.log(
      "noteDate, firstPaymentDate, paymentFrequency, interestRate, terms",
      { noteDate, firstPaymentDate, paymentFrequency, interestRate, terms }
    );
    calMatDate();
  }, [noteDate, firstPaymentDate, paymentFrequency, interestRate, terms]);

  useEffect(() => {
    previewProgressRef.current = previewProgress;
  }, [previewProgress]);

  const [init, setInit] = useState(true);
  useEffect(() => {
    if (!open) {
      return;
    }
    if (init && loan_saved === "YES") {
      setInit(false);
      return;
    }
    updateLateFeeAndGracePeriod({ record });
    setInit(false);
  }, [open, paymentFrequency]);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const handleChangePaymentFrequency = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const paymentFrequency = event.target.value;
  };
  const handleClickOpen = () => {
    setInit(true);
    setOpen(true);
    setFilePath("");
    setGenerateFileInfo(null);
  };

  const handleClose = () => {
    setOpen(false);
    setFilePath("");
    setGenerateFileInfo(null);
    setSubmitTitle("Approve");
    setIsSubmitting(false);
    resetPreviewLoadingState();
    refresh();
  };

  const resetSubmitState = () => {
    setSubmitTitle("Approve");
    setIsSubmitting(false);
  };

  const updatePreviewProgress = (progress: number, label: string) => {
    setPreviewProgress(progress);
    setPreviewProgressLabel(label);
  };

  const clearGenerateProgressTimer = () => {
    if (generateProgressTimerRef.current) {
      clearInterval(generateProgressTimerRef.current);
      generateProgressTimerRef.current = null;
    }
  };

  const startGenerateProgressTimer = () => {
    clearGenerateProgressTimer();
    generateProgressTimerRef.current = setInterval(() => {
      setPreviewProgress((prev) => {
        if (prev >= 84) {
          return prev;
        }
        const step =
          prev < 18 ? 0.6 : prev < 38 ? 0.95 : prev < 62 ? 0.75 : 0.4;
        return Math.min(84, Number((prev + step).toFixed(2)));
      });
    }, 500);
  };

  const resetPreviewLoadingState = () => {
    clearGenerateProgressTimer();
    setPreviewTitle("Preview");
    setIsPreviewLoading(false);
    setPreviewProgress(0);
    setPreviewProgressLabel("");
    downloadStartProgressRef.current = 25;
  };

  const formatRate = (num: any) => {
    if (num == "" || num == null || num == 0) {
      return "0.00%";
    } else {
      return num + "%";
    }
  };

  const defautRateOptionList: { label: string; value: any }[] = [];
  defautRateOptionList.push({ label: "Select", value: "" });
  if (record.rateData) {
    for (let i = 0; i < Object.keys(record.rateData).length; i++) {
      // console.log("record.rateData[i] ===>" + i, record.rateData[i]);
      defautRateOptionList.push({
        label: formatRate(record.rateData[i]),
        value: record.rateData[i],
      });
    }
  }
  // console.log("defautRateOptionList ===>", defautRateOptionList);
  const defautTermsList: { label: any; value: any }[] = [];
  defautTermsList.push({ label: "Select", value: 0 });
  if (record?.termsData) {
    for (let i = 0; i < record.termsData.length; i++) {
      defautTermsList.push({
        label: record.termsData[i],
        value: parseInt(record.termsData[i]),
      });
    }
  }

  const defautPaymentFreqList: { label: any; value: any }[] = [];
  if (record.paymentFrequencyData) {
    for (let i = 0; i < record.paymentFrequencyData.length; i++) {
      defautPaymentFreqList.push({
        label: record.paymentFrequencyData[i].name,
        value: record.paymentFrequencyData[i].bbkey,
      });
    }
  }

  const defautOriginationFeeTypeList: { label: any; value: any }[] = [];
  defautOriginationFeeTypeList.push({ label: "Select", value: "" });
  defautOriginationFeeTypeList.push({
    label: "Add to Loan Amount",
    value: "Add to Loan Amount",
  });
  defautOriginationFeeTypeList.push({
    label: "Deduct from Funded Amount",
    value: "Deduct from Funded Amount",
  });

  const defautAccountTypeList: { label: any; value: any }[] = [];
  defautAccountTypeList.push({ label: "Select", value: "" });
  defautAccountTypeList.push({ label: "Checking", value: "Checking" });
  defautAccountTypeList.push({ label: "Savings", value: "Savings" });

  const calMatDate = async () => {
    let checkCalFun = true;
    // alert("calMatDate called");
    setPreviewTitle("Preview");

    if (
      noteDate == "" ||
      noteDate == null ||
      noteDate == undefined ||
      noteDate == "YYYY-MM-DD" ||
      noteDate == "0000-00-00"
    ) {
      checkCalFun = false;
    }
    // console.log("checkCalFun step 2===>", checkCalFun ? "yes" : "no");
    if (
      firstPaymentDate == "" ||
      firstPaymentDate == null ||
      firstPaymentDate == undefined ||
      firstPaymentDate == "YYYY-MM-DD" ||
      firstPaymentDate == "0000-00-00"
    ) {
      checkCalFun = false;
    }
    if (dayjs(firstPaymentDate).isBefore(dayjs(), "day")) {
      errorNotify("First Payment Date must be greater than today");
      checkCalFun = false;
    }
    if (dayjs(firstPaymentDate).isBefore(dayjs(noteDate), "day")) {
      errorNotify("First Payment Date must be greater than Note Date");
      checkCalFun = false;
    }
    // console.log("checkCalFun step 2===>", checkCalFun ? "yes" : "no");
    if (
      paymentFrequency == "" ||
      paymentFrequency == null ||
      paymentFrequency == undefined
    ) {
      checkCalFun = false;
    }
    // console.log("checkCalFun step 2-2===>", checkCalFun ? "yes" : "no");
    // if (
    //   interestRate === "" ||
    //   interestRate === null ||
    //   interestRate === undefined
    // ) {
    //   checkCalFun = false;
    // }
    // console.log(
    //   "checkCalFun step 3===>",
    //   interestRate,
    //   checkCalFun ? "yes" : "no"
    // );
    if (
      terms.toString() == "" ||
      terms == null ||
      terms == undefined ||
      terms == 0 ||
      isNaN(terms)
    ) {
      checkCalFun = false;
    }
    // console.log("checkCalFun step 4===>", checkCalFun ? "yes" : "no");
    const formJson = {
      amouant: record.amountSubmit,
      amount: record.amountSubmit,
      note_date: noteDate,
      iterm: terms,
      payment_frequency: paymentFrequency,
      rate: interestRate,
      first_payment_date: firstPaymentDate,
    };

    // console.log("calMatDate formJson===>", formJson);
    if (checkCalFun == false) {
      // alert("checkCalFun is false");
      return false;
    } else {
      const reqUrl = `calculate/getmaturitydate`;
      const response = await sendRequest(reqUrl, {
        id: appId,
        data: formJson,
      });
      if (response && response.status == "200") {
        setMaturityDate(
          dayjs(response.data.maturity_date).format("YYYY-MM-DD")
        );
        setPaymentCount(response.data.payment_count);
        setIsSubmit(true);
      } else {
        errorNotify("Error in calculating maturity date");
      }
    }
  };

  const updateLateFeeAndGracePeriod = ({ ...props }) => {
    const record = props.record;
    let max_latefee = record.lateFeeData.reduce(function (
      prev: any,
      current: any
    ) {
      return prev.lateFee > current.lateFee ? prev : current;
    });
    let adjust_latefee = record.lateFeeAdjust;
    let max_grace_period = record.gracePeriodData.reduce(function (
      prev: any,
      current: any
    ) {
      return prev.gracePeriod > current.gracePeriod ? prev : current;
    });

    let adjust_grace_period = record.gracePeriodAdjust;
    let latefee = max_latefee;
    let graceperiod = max_grace_period;

    if (
      paymentFrequency == "Monthly" ||
      paymentFrequency == "Month End Payment" ||
      paymentFrequency == "Single Repayment"
    ) {
      latefee = max_latefee;
      graceperiod = 16;
    } else if (paymentFrequency == "Semimonthly") {
      latefee = toDecimal(max_latefee / 2, 2);
      graceperiod = 8;
    } else if (paymentFrequency == "Weekly") {
      latefee = toDecimal(max_latefee / 4, 2);
      graceperiod = 6;
    } else if (paymentFrequency == "Bi-Weekly") {
      latefee = toDecimal(max_latefee / 2, 2);
      graceperiod = 8;
    }

    console.log("check graceperiod 1==>", graceperiod);
    if (adjust_latefee == "No" || adjust_latefee == "") {
      // latefee = max_latefee;
      let customlatefee = record?.customlatefee;
      if (
        paymentFrequency == "Monthly" ||
        paymentFrequency == "Month End Payment"
      ) {
        latefee = customlatefee?.["M11"] ? customlatefee["M11"] : latefee;
      } else if (paymentFrequency == "Single Repayment") {
        latefee = customlatefee?.["ONCE"] ? customlatefee["ONCE"] : latefee;
      } else if (paymentFrequency == "Semimonthly") {
        latefee = customlatefee?.["M12"] ? customlatefee["M12"] : latefee;
      } else if (paymentFrequency == "Weekly") {
        latefee = customlatefee?.["W11"] ? customlatefee["W11"] : latefee;
      } else if (paymentFrequency == "Bi-Weekly") {
        latefee = customlatefee?.["W21"] ? customlatefee["W21"] : latefee;
      }
    }
    if (adjust_grace_period == "No" || adjust_grace_period == "") {
      // graceperiod = record.iGracePeriod
      //   ? record.iGracePeriod
      //   : max_grace_period;
      let customGracePeriodData = record?.customGracePeriodData;
      //       {
      //     "M11": 10,
      //     "M12": 10,
      //     "W21": 10,
      //     "W11": 10
      // }
      if (customGracePeriodData) {
        if (
          paymentFrequency == "Monthly" ||
          paymentFrequency == "Month End Payment"
        ) {
          graceperiod = customGracePeriodData["M11"]
            ? customGracePeriodData["M11"]
            : graceperiod;
        } else if (paymentFrequency == "Single Repayment") {
          graceperiod = customGracePeriodData["ONCE"]
            ? customGracePeriodData["ONCE"]
            : graceperiod;
        } else if (paymentFrequency == "Semimonthly") {
          graceperiod = customGracePeriodData["M12"]
            ? customGracePeriodData["M12"]
            : graceperiod;
        } else if (paymentFrequency == "Weekly") {
          graceperiod = customGracePeriodData["W11"]
            ? customGracePeriodData["W11"]
            : graceperiod;
        } else if (paymentFrequency == "Bi-Weekly") {
          graceperiod = customGracePeriodData["W21"]
            ? customGracePeriodData["W21"]
            : graceperiod;
        }
        console.log("check graceperiod 2==>", graceperiod);
      }
    }
    console.log("check graceperiod 3==>", graceperiod);
    setGracePeriodDay(graceperiod);
    setLateFee(latefee);
  };

  function toDecimal(x: any, y: any) {
    var f = parseFloat(x);
    if (isNaN(f)) {
      return;
    }
    f = Math.round(x * 100) / 100;
    return f;
  }

  const getApproveDialogFieldValue = (form: HTMLFormElement, name: string) => {
    const formData = new FormData(form);
    const value = formData.get(name);

    return typeof value === "string" ? value : "";
  };

  const getApproveDialogFormData = (form: HTMLFormElement | null) => {
    if (!form) {
      return null;
    }

    return {
      loannum: getApproveDialogFieldValue(form, "loannum"),
      loanamount: getApproveDialogFieldValue(form, "loanamount").replace(
        /,/g,
        ""
      ),
      interest_rate: getApproveDialogFieldValue(form, "interest_rate"),
      terms: getApproveDialogFieldValue(form, "terms"),
      note_date: getApproveDialogFieldValue(form, "note_date"),
      first_payment_date: getApproveDialogFieldValue(
        form,
        "first_payment_date"
      ),
      payment_frequency: getApproveDialogFieldValue(form, "payment_frequency"),
      number_payments: getApproveDialogFieldValue(form, "number_payments"),
      maturity_date: getApproveDialogFieldValue(form, "maturity_date"),
      origination_fee_amount: getApproveDialogFieldValue(
        form,
        "origination_fee_amount"
      ).replace(/,/g, ""),
      origination_fee_type: getApproveDialogFieldValue(
        form,
        "origination_fee_type"
      ),
      grace_period: getApproveDialogFieldValue(form, "grace_period"),
      late_fee: getApproveDialogFieldValue(form, "late_fee").replace(/,/g, ""),
      sDayCountConvention: getApproveDialogFieldValue(
        form,
        "sDayCountConvention"
      ),
      iPaymentRoundUp: getApproveDialogFieldValue(form, "iPaymentRoundUp"),
    };
  };

  const handlePreviewApprove = async ({ ...props }) => {
    if (isSubmitting) {
      return false;
    }

    const { appId, event } = props;
    setIsPreviewLoading(true);
    setPreviewTitle("loading");
    updatePreviewProgress(5, "Saving data...");
    const newSubFormData = getApproveDialogFormData(approveFormRef.current);
    // console.log("preview newSubFormData===>", newSubFormData);
    if (!newSubFormData) {
      errorNotify("Approve form is not ready");
      resetPreviewLoadingState();
      return false;
    }
    let checkSubmitCal = true;
    if (
      newSubFormData.loannum == "" ||
      newSubFormData.loannum == null ||
      newSubFormData.loannum == undefined
    ) {
      checkSubmitCal = false;
    }
    if (
      newSubFormData.loanamount == "" ||
      newSubFormData.loanamount == null ||
      newSubFormData.loanamount == undefined
    ) {
      checkSubmitCal = false;
    }
    if (
      newSubFormData.interest_rate == "" ||
      newSubFormData.interest_rate == null ||
      newSubFormData.interest_rate == undefined
    ) {
      checkSubmitCal = false;
    }
    if (
      newSubFormData.terms == "" ||
      newSubFormData.terms == null ||
      newSubFormData.terms == undefined
    ) {
      checkSubmitCal = false;
    }
    if (
      newSubFormData.note_date == "" ||
      newSubFormData.note_date == null ||
      newSubFormData.note_date == undefined
    ) {
      checkSubmitCal = false;
    }
    if (
      newSubFormData.first_payment_date == "" ||
      newSubFormData.first_payment_date == null ||
      newSubFormData.first_payment_date == undefined
    ) {
      checkSubmitCal = false;
    }
    if (
      newSubFormData.payment_frequency == "" ||
      newSubFormData.payment_frequency == null ||
      newSubFormData.payment_frequency == undefined
    ) {
      checkSubmitCal = false;
    }
    if (
      newSubFormData.number_payments == "" ||
      newSubFormData.number_payments == null ||
      newSubFormData.number_payments == undefined
    ) {
      checkSubmitCal = false;
    }
    if (
      newSubFormData.maturity_date == "" ||
      newSubFormData.maturity_date == null ||
      newSubFormData.maturity_date == undefined
    ) {
      checkSubmitCal = false;
    }
    if (
      newSubFormData.origination_fee_amount == "" ||
      newSubFormData.origination_fee_amount == null ||
      newSubFormData.origination_fee_amount == undefined
    ) {
      newSubFormData.origination_fee_amount = "0";
    }
    if (
      newSubFormData?.origination_fee_type == "" &&
      newSubFormData?.origination_fee_amount != "0" &&
      newSubFormData?.origination_fee_amount != "0.00"
    ) {
      errorNotify("Please select Origination Fee Type");
      checkSubmitCal = false;
    }

    if (dayjs(newSubFormData.first_payment_date).isBefore(dayjs(), "day")) {
      errorNotify("First Payment Date must be greater than today");
      checkSubmitCal = false;
      resetPreviewLoadingState();
      return false;
    }
    if (
      dayjs(newSubFormData.first_payment_date).isBefore(
        dayjs(newSubFormData.note_date),
        "day"
      )
    ) {
      errorNotify("First Payment Date must be greater than Note Date");
      checkSubmitCal = false;
      resetPreviewLoadingState();
      return false;
    }

    if (checkSubmitCal == false) {
      errorNotify("Please fill required fields");
      resetPreviewLoadingState();
      return false;
    }

    const reqUrl = `applications/actions/saveappinfo`;
    const response = await sendRequest(reqUrl, {
      id: appId,
      data: newSubFormData,
    });

    if (response == undefined || response == null) {
      resetPreviewLoadingState();
      return Promise.resolve();
    }
    if (response && (response.status == "200" || response.code == "200")) {
      const message = response.message;
      const responseCode = response.code;
      if (message == "Lost Template File") {
        resetPreviewLoadingState();
        errorNotify("Missing Template File");
      } else if (message == "event not exist") {
        resetPreviewLoadingState();
        errorNotify("review event not exist");
      } else {
        updatePreviewProgress(12, "Generating file on server...");
        startGenerateProgressTimer();

        await downloadFileFun(
          appId,
          "approve_preview.pdf",
          "execute2approve_preview",
          "",
          {
            onError: (message: string) => {
              errorNotify(message);
            },
            openInNewTab: false,
            onStageChange: (stage) => {
              if (stage === "generating") {
                updatePreviewProgress(
                  Math.max(previewProgressRef.current, 12),
                  "Generating file on server..."
                );
                startGenerateProgressTimer();
              }
              if (stage === "downloading") {
                clearGenerateProgressTimer();
                downloadStartProgressRef.current =
                  previewProgressRef.current > 12
                    ? previewProgressRef.current
                    : 12;
                setPreviewProgressLabel("Downloading to browser...");
              }
            },
            onDownloadProgress: (percent) => {
              if (typeof percent !== "number") {
                setPreviewProgress((prev) => Math.min(99, prev + 0.15));
                return;
              }
              const base = downloadStartProgressRef.current;
              const mapped = base + (percent / 100) * (100 - base);
              setPreviewProgress((prev) =>
                Math.max(prev, Math.min(100, Math.round(mapped)))
              );
            },
          }
        );
        clearGenerateProgressTimer();
        updatePreviewProgress(100, "Preview ready");
        await new Promise((resolve) => setTimeout(resolve, 600));
        refresh();
        resetPreviewLoadingState();
      }
    } else {
      errorNotify(response?.message || "Data not saved!");

      resetPreviewLoadingState();
    }
  };
  const handleSaveInfoApprove = async ({ ...props }) => {
    const { appId, event } = props;
    setSaveGeneralInfoTitle("loading");
    setDisabledTab(true);

    const newSubFormData = getApproveDialogFormData(approveFormRef.current);
    if (!newSubFormData) {
      errorNotify("Approve form is not ready");
      setSaveGeneralInfoTitle("Save");
      return false;
    }
    let checkSubmitCal = true;
    if (
      newSubFormData.loannum == "" ||
      newSubFormData.loannum == null ||
      newSubFormData.loannum == undefined
    ) {
      checkSubmitCal = false;
    }
    if (
      newSubFormData.loanamount == "" ||
      newSubFormData.loanamount == null ||
      newSubFormData.loanamount == undefined
    ) {
      checkSubmitCal = false;
    }
    if (
      newSubFormData.interest_rate == "" ||
      newSubFormData.interest_rate == null ||
      newSubFormData.interest_rate == undefined
    ) {
      checkSubmitCal = false;
    }
    if (
      newSubFormData.terms == "" ||
      newSubFormData.terms == null ||
      newSubFormData.terms == undefined
    ) {
      checkSubmitCal = false;
    }
    if (
      newSubFormData.note_date == "" ||
      newSubFormData.note_date == null ||
      newSubFormData.note_date == undefined
    ) {
      checkSubmitCal = false;
    }
    if (
      newSubFormData.first_payment_date == "" ||
      newSubFormData.first_payment_date == null ||
      newSubFormData.first_payment_date == undefined
    ) {
      checkSubmitCal = false;
    }
    if (
      newSubFormData.payment_frequency == "" ||
      newSubFormData.payment_frequency == null ||
      newSubFormData.payment_frequency == undefined
    ) {
      checkSubmitCal = false;
    }
    if (
      newSubFormData.number_payments == "" ||
      newSubFormData.number_payments == null ||
      newSubFormData.number_payments == undefined
    ) {
      checkSubmitCal = false;
    }
    if (
      newSubFormData.maturity_date == "" ||
      newSubFormData.maturity_date == null ||
      newSubFormData.maturity_date == undefined
    ) {
      checkSubmitCal = false;
    }
    if (
      newSubFormData.origination_fee_amount == "" ||
      newSubFormData.origination_fee_amount == null ||
      newSubFormData.origination_fee_amount == undefined
    ) {
      newSubFormData.origination_fee_amount = "0";
    }
    // alert(
    //   "newSubFormData?.origination_fee_type ===>" +
    //     newSubFormData?.origination_fee_type
    // );
    // alert(
    //   "newSubFormData?.origination_fee_amount ===>" +
    //     newSubFormData?.origination_fee_amount
    // );

    if (
      newSubFormData?.origination_fee_type == "" &&
      newSubFormData?.origination_fee_amount != "0" &&
      newSubFormData?.origination_fee_amount != "0.00"
    ) {
      errorNotify("Please select Origination Fee Type");
      checkSubmitCal = false;
    }

    if (dayjs(newSubFormData.first_payment_date).isBefore(dayjs(), "day")) {
      errorNotify("First Payment Date must be greater than today");
      checkSubmitCal = false;
      setSaveGeneralInfoTitle("Preview");
      return false;
    }
    if (
      dayjs(newSubFormData.first_payment_date).isBefore(
        dayjs(newSubFormData.note_date),
        "day"
      )
    ) {
      errorNotify("First Payment Date must be greater than Note Date");
      checkSubmitCal = false;
      setSaveGeneralInfoTitle("Preview");
      return false;
    }

    if (checkSubmitCal == false) {
      errorNotify("Please fill required fields");
      setSaveGeneralInfoTitle("Preview");
      return false;
    }

    const reqUrl = `applications/actions/saveappinfo`;
    const response = await sendRequest(reqUrl, {
      id: appId,
      data: newSubFormData,
    });

    if (response == undefined || response == null) {
      return Promise.resolve();
    }
    if (response && (response.status == "200" || response.code == "200")) {
      //only save info no need to generate document, so just show success message
      successNotify("Data saved successfully");
      refresh();
      setSaveGeneralInfoTitle("Save");
      //延迟2秒
      setTimeout(() => {
        setDisabledTab(false);
      }, 2000);
    } else {
      errorNotify(response?.message || "Data not saved!");
      setSaveGeneralInfoTitle("Save");
      //延迟2秒
      setTimeout(() => {
        setDisabledTab(false);
      }, 2000);
    }
  };

  const handleApproveSend = async ({ ...props }) => {
    let { appId } = props;
    const reqUrl = `applications/actions/notify/toApproved`;
    const response = await sendRequest(reqUrl, {
      id: appId,
      data: { option: "approve" },
    });
    if (response && (response.status == "200" || response.code == "200")) {
      successNotify("Data saved successfully");
      if (cbfun) {
        cbfun("Approved");
      }
      handleClose();
    }
  };
  // console.log("termsDefineApprove===>", termsDefineApprove);
  // console.log(
  //   "bank_user_deposit_account_info===>",
  //   record?.bank_user_deposit_account_info?.sOrganizationType
  // );
  const [readOnly, setReadOnly] = useState(true);
  const [showDownloadIcon, setShowDownloadIcon] = useState(false);
  let defaultOriginationFeeType = record?.origination_fee_type;
  if (
    record?.origination_fee_amount == 0 ||
    record?.origination_fee_amount == "0" ||
    record?.origination_fee_amount == "0.00"
  ) {
    defaultOriginationFeeType = "";
  }
  // const [originationFeeTypeRequired, setOriginationFeeTypeRequired] = useState(
  //   defaultOriginationFeeType
  // );
  const [originationFeeTypeRequired, setOriginationFeeTypeRequired] = useState(
    loan_saved == "YES"
      ? loan_saved_origination_fee_type
      : defaultOriginationFeeType
  );

  const showDisbursementTab = termsDefineApprove?.includes("disbursement");
  const showDepositAccountTab =
    record?.bank_user_deposit_account_info?.sOrganizationType === "Bank" ||
    record?.bank_user_deposit_account_info?.sOrganizationType ===
      "Credit Union";
  const showPurchaseDetailTab = termsDefineApprove?.includes("purchaseinfo");
  const showCollateralDetailTab = termsDefineApprove?.includes("collateral");

  let nextTabIndex = 1;
  const disbursementTabIndex = showDisbursementTab ? nextTabIndex++ : -1;
  const depositAccountTabIndex = showDepositAccountTab ? nextTabIndex++ : -1;
  const purchaseDetailTabIndex = showPurchaseDetailTab ? nextTabIndex++ : -1;
  const collateralDetailTabIndex = showCollateralDetailTab
    ? nextTabIndex++
    : -1;

  return (
    <React.Fragment>
      <Button
        id="btn-application-tonotify-approve"
        label="Approve"
        variant="contained"
        size="medium"
        color="success"
        sx={{ marginLeft: "10px", width: "120px" }}
        onClick={handleClickOpen}
      />
      <Dialog
        id={"dialog-application-tonotify-approve-" + appId}
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth="lg"
        PaperProps={{
          component: "form",
          ref: approveFormRef,
          onSubmit: async (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            if (isSubmitting || isPreviewLoading) {
              return false;
            }

            const approveForm = approveFormRef.current ?? event.currentTarget;
            let checkCal = await calMatDate();
            // console.log("checkCal===>", checkCal);
            if (checkCal == false) {
              errorNotify("Please fill all required fields");
              return false;
            } else {
              let newSubFormData = getApproveDialogFormData(approveForm);
              if (!newSubFormData) {
                console.log("newSubFormData===>", newSubFormData);
                errorNotify("Approve form is not ready");
                return false;
              }
              if (
                dayjs(newSubFormData.first_payment_date).isBefore(
                  dayjs(),
                  "day"
                )
              ) {
                errorNotify("First Payment Date must be greater than today");
                return false;
              }
              if (
                dayjs(newSubFormData.first_payment_date).isBefore(
                  dayjs(newSubFormData.note_date),
                  "day"
                )
              ) {
                errorNotify(
                  "First Payment Date must be greater than Note Date"
                );
                return false;
              }

              setIsSubmitting(true);
              setSubmitTitle("loading");
              const reqUrl = `applications/actions/saveappinfo`;
              const response = await sendRequest(reqUrl, {
                id: appId,
                data: newSubFormData,
              });
              if (
                response &&
                (response.status == "200" || response.code == "200")
              ) {
                successNotify("Document is being generated");
                const message = response.message;
                const responseCode = response.code;
                if (message == "Lost Template File") {
                  errorNotify("Missing Template File");
                } else if (message == "event not exist") {
                  errorNotify("review event not exist");
                } else {
                  successNotify("Document is being generated");
                  const filetype = "approve_preview.pdf";
                  const filekey = "execute2approve_preview";
                  const generalFileUrl =
                    "applications/pdfs/fillForm/generatedPdf";
                  const formData = new FormData();
                  const formJson = Object.fromEntries(
                    (formData as any).entries()
                  );
                  formJson.filetype = filetype;
                  formJson.filekey = filekey;
                  formJson.exectype = "acceptUpload";
                  formJson.sReview = "approve";
                  const fileResponse = await sendRequest(generalFileUrl, {
                    id: appId,
                    data: formJson,
                  });
                  // console.log("fileResponse===>", fileResponse);
                  if (fileResponse?.code == 200) {
                    const fileUrl = fileResponse?.filekey;
                    setFilePath(fileUrl);
                    setGenerateFileInfo({
                      filename:
                        fileResponse?.filename || fileResponse?.filekey || "",
                      filetype: fileResponse?.filetype || "",
                      filekey: fileResponse?.filekey || "",
                      filelink: fileResponse?.filelink || "",
                      docId: fileResponse?.docId || 0,
                    });
                    resetSubmitState();
                  } else {
                    errorNotify(
                      fileResponse?.message || "File generation failed!"
                    );
                  }
                  resetSubmitState();
                }
              } else {
                errorNotify(response?.message || "Data not saved!");

                resetSubmitState();
              }
            }
          },
        }}
      >
        <DialogTitle
          sx={{
            borderBottom: "1px solid #e5e5e5",
            mb: 2,
          }}
        >
          <CustomApplicationDialogTitle record={record} subTitle="Approve" />
        </DialogTitle>

        <DialogContent>
          {/* <DialogApplicationBaseInfo appId={appId} record={record} /> */}
          {/* if have filepath, will hide other form */}
          {filePath ? (
            <>
              <List
                sx={{
                  width: "100%",
                  maxWidth: "100%",
                  bgcolor: "background.paper",
                }}
              >
                <ListItem key={appId}>
                  <Link
                    sx={{
                      fontSize: "16px",
                      textDecoration: "none",
                      cursor: "pointer",
                    }}
                    //这个会重新生成文件， 应直接下载
                    // onClick={async () => {
                    //   setShowDownloadIcon(true);
                    //   await downloadFileFun(
                    //     appId,
                    //     appId + "-approve",
                    //     "approve",
                    //     filePath
                    //   );
                    //   setShowDownloadIcon(false);
                    // }}
                  >
                    Closing Documents Pending Applicant Signature
                    {/* {!showDownloadIcon && (
                      <DownloadIcon
                        sx={{ fontSize: "20px", verticalAlign: "Bottom" }}
                      />
                    )}
                    {showDownloadIcon && (
                      <CircularProgress
                        size={16}
                        color="inherit"
                        sx={{
                          marginLeft: "10px",
                          verticalAlign: "Bottom",
                        }}
                      />
                    )} */}
                    {generateFileInfo && generateFileInfo.filekey && (
                      <DownloadFieldLink
                        key={`doc_link_${appId}_${generateFileInfo.docId}_${
                          generateFileInfo?.filename || "na"
                        }_${String(generateFileInfo?.filelink || "na")}`}
                        // filename={appId + "_" + generateFileInfo?.filename}
                        filename={
                          appId +
                          "_Closing Documents Pending Applicant Signature"
                        }
                        filelink={generateFileInfo?.filelink}
                      />
                    )}
                  </Link>
                </ListItem>
                <ListItem key="text-body">
                  <Typography variant="body2" color="text.secondary">
                    Click 'Send' Button, Application {appId} status will move to
                    Approved. To review this application, please select
                    "Approved" in the drop down menu.
                  </Typography>
                </ListItem>
              </List>
            </>
          ) : (
            <>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                  value={value}
                  onChange={handleChange}
                  aria-label="basic tabs example"
                >
                  <Tab label="Terms" {...a11yProps(0)} disabled={disabledTab} />
                  {showDisbursementTab && (
                    <Tab
                      label="Disbursement"
                      {...a11yProps(disbursementTabIndex)}
                      disabled={disabledTab}
                    />
                  )}
                  {showDepositAccountTab && (
                    <Tab
                      label="Deposit Account"
                      {...a11yProps(depositAccountTabIndex)}
                      disabled={disabledTab}
                    />
                  )}
                  {showPurchaseDetailTab && (
                    <Tab
                      label="Purchase Detail"
                      {...a11yProps(purchaseDetailTabIndex)}
                      disabled={disabledTab}
                    />
                  )}
                  {showCollateralDetailTab && (
                    <Tab
                      label="Collateral Detail"
                      {...a11yProps(collateralDetailTabIndex)}
                      disabled={disabledTab}
                    />
                  )}
                </Tabs>
              </Box>
              <Box
                sx={{
                  width: "100%",
                  height: "600px",
                  paddingBottom: "10px",
                  overflowY: "auto",
                  // 如果父元素高度不够， height 设置为 auto
                  maxHeight: "100%",
                }}
              >
                {/* start Approved Form */}
                <CustomTabPanel
                  value={value}
                  index={0}
                  sx={{
                    "& input[readonly], & textarea[readonly]": {
                      backgroundColor: "#e5e5e5",
                    },
                    "& .MuiInputBase-readOnly": {
                      backgroundColor: "#e5e5e5",
                      borderRadius: "10px",
                    },
                  }}
                >
                  <Grid
                    container
                    sx={{
                      position: "sticky",
                      top: "25px",
                      zIndex: 2,
                      justifyContent: "flex-end",
                      // backgroundColor: "#fff",
                      pb: 1,
                    }}
                  >
                    <Grid item>
                      <CustomButtonSave
                        label={"Save"}
                        endIcon={
                          saveGeneralInfoTitle == "loading" ? (
                            <CircularProgress size={16} color="inherit" />
                          ) : null
                        }
                        variant="text"
                        size="medium"
                        color="primary"
                        sx={{ width: "120px" }}
                        onClick={(event: any) =>
                          handleSaveInfoApprove({ event, appId })
                        }
                        disabled={
                          saveGeneralInfoTitle == "loading" ? true : false
                        }
                      />
                    </Grid>
                  </Grid>
                  <Grid container sx={{ mb: 2, pb: 2 }}>
                    {/* Loan Number */}
                    <Grid sx={{ mb: 2 }} container>
                      <Grid item xs={5} sx={{ pt: 1 }}>
                        <HeaderLabelTitle title="Loan Number" required />
                      </Grid>
                      <Grid item xs={5}>
                        <CustomControlEditTextField
                          name="loannum"
                          defaultValue={record.sLoanNum}
                          onChange={handleInputChange}
                          required={true}
                          helperText="no"
                          className="numericText"
                        />
                      </Grid>
                      <Grid item xs={2}></Grid>
                    </Grid>
                    {/* loan amount */}
                    <Grid sx={{ mb: 2 }} container>
                      <Grid item xs={5} sx={{ pt: 1 }}>
                        <HeaderLabelTitle title="Loan Amount" required />
                      </Grid>

                      <Grid item xs={5}>
                        <CustomControlMoneyEditTextField
                          name="loanamount"
                          defaultValue={record.amountReview}
                          min={min_amount}
                          max={max_amount}
                          readonly={true}
                          onChange={handleInputChange}
                          required={true}
                          prefix={false}
                          helperText="no"
                          className="amountText"
                        />
                      </Grid>
                      <Grid item xs={2}></Grid>
                    </Grid>
                    <Grid sx={{ mb: 2 }} container>
                      <Grid item xs={5} sx={{ pt: 1 }}>
                        <HeaderLabelTitle title="Interest Rate" required />
                      </Grid>
                      <Grid item xs={5}>
                        <CustomEditControlSelect
                          variant="outlined"
                          id="interest_rate"
                          name="interest_rate"
                          value={interestRate == 0.0 ? 0 : interestRate}
                          optionlist={defautRateOptionList}
                          required={true}
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            if (e.target.value != undefined) {
                              setInterestRate(e.target.value.toString());
                            }
                            handleInputChange(e);
                          }}
                          helperText="no"
                          className="numericText"
                        />
                      </Grid>
                      <Grid item xs={2}></Grid>
                    </Grid>

                    <Grid sx={{ mb: 2 }} container>
                      <Grid item xs={5} sx={{ pt: 1 }}>
                        <HeaderLabelTitle title="Term (Months)" required />
                      </Grid>
                      <Grid item xs={5}>
                        <CustomEditControlSelect
                          variant="outlined"
                          id="terms"
                          name="terms"
                          value={terms}
                          optionlist={defautTermsList}
                          required={true}
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            if (e.target.value != undefined) {
                              setTerms(parseInt(e.target.value));
                            }
                            handleInputChange(e);
                          }}
                          helperText="no"
                          className="numericText"
                        />
                      </Grid>
                      <Grid item xs={2}></Grid>
                    </Grid>

                    <Grid sx={{ mb: 2 }} container>
                      <Grid item xs={5} sx={{ pt: 1 }}>
                        <HeaderLabelTitle
                          title="Note Date (Funding Date)"
                          required
                        />
                      </Grid>
                      <Grid item xs={5}>
                        <CustomDateTextInput
                          id="note_date"
                          name="note_date"
                          value={
                            noteDate
                              ? dayjs(noteDate).format("YYYY-MM-DD")
                              : "today"
                          }
                          required={true}
                          onChange={(value: any) => {
                            setNoteDate(value);
                          }}
                          className="dateText"
                        />
                      </Grid>
                      <Grid item xs={2}></Grid>
                    </Grid>

                    <Grid sx={{ mb: 2 }} container>
                      <Grid item xs={5} sx={{ pt: 1 }}>
                        <HeaderLabelTitle title="First Payment Date" required />
                      </Grid>
                      <Grid item xs={5}>
                        <CustomDateTextInput
                          id="first_payment_date"
                          name="first_payment_date"
                          value={firstPaymentDate}
                          required={true}
                          onChange={(value: any) => {
                            setFirstPaymentDate(value);
                          }}
                        />
                      </Grid>
                      <Grid item xs={2}></Grid>
                    </Grid>

                    <Grid sx={{ mb: 2 }} container>
                      <Grid item xs={5} sx={{ pt: 1 }}>
                        <HeaderLabelTitle title="Payment Frequency" required />
                      </Grid>
                      <Grid item xs={5}>
                        <CustomSelect
                          fullWidth={true}
                          id="payment_frequency"
                          name="payment_frequency"
                          value={paymentFrequency}
                          optionlist={defautPaymentFreqList}
                          required={true}
                          variant="outlined"
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            if (e.target.value != "") {
                              setPaymentFrequency(e.target.value);
                            }
                            handleInputChange(e);
                          }}
                        />
                      </Grid>
                      <Grid item xs={2}></Grid>
                    </Grid>

                    <Grid sx={{ mb: 2 }} container>
                      <Grid item xs={5} sx={{ pt: 1 }}>
                        <HeaderLabelTitle
                          fullWidth
                          title="Number Of Payments"
                          required
                        />
                      </Grid>
                      <Grid item xs={5}>
                        <TextField
                          fullWidth
                          type="text"
                          variant="outlined"
                          id="number_payments"
                          name="number_payments"
                          required={true}
                          value={paymentCount}
                          onChange={(e) => {
                            handleInputChange(e);
                          }}
                          sx={{
                            background: "#e5e5e5",
                            "& input": { pl: "14px", pt: "5px" },
                            borderRadius: "10px",
                          }}
                          className="numericText"
                        />
                      </Grid>
                      <Grid item xs={2}></Grid>
                    </Grid>

                    <Grid sx={{ mb: 2 }} container>
                      <Grid item xs={5} sx={{ pt: 1 }}>
                        <HeaderLabelTitle title="Maturity Date" required />
                      </Grid>
                      <Grid item xs={5}>
                        <TextField
                          fullWidth
                          type="text"
                          variant="outlined"
                          id="maturity_date"
                          name="maturity_date"
                          required={true}
                          value={maturityDate}
                          InputProps={{ readOnly: true }}
                          sx={{
                            background: "#e5e5e5",
                            "& input": { pl: "14px", pt: "5px" },
                            borderRadius: "10px",
                          }}
                          onChange={(e) => {
                            handleInputChange(e);
                          }}
                          className="dateText"
                        />
                      </Grid>
                      <Grid item xs={2}></Grid>
                    </Grid>

                    {/* Grace Period (Days) textField */}
                    <Grid sx={{ mb: 2 }} container>
                      <Grid item xs={5} sx={{ pt: 1 }}>
                        <HeaderLabelTitle title="Grace Period (Days)" />
                      </Grid>
                      <Grid item xs={5}>
                        <TextField
                          id="grace_period"
                          name="grace_period"
                          value={gracePeriodDay}
                          variant="outlined"
                          InputProps={{ readOnly: true }}
                          sx={{
                            background: "#e5e5e5",
                            "& input": { pl: "14px", pt: "5px" },
                            borderRadius: "10px",
                          }}
                          onChange={(e) => {
                            handleInputChange(e);
                          }}
                          className="numericText"
                        />
                      </Grid>
                      <Grid item xs={2}></Grid>
                    </Grid>
                    {/* late_fee textField */}
                    <Grid sx={{ mb: 2 }} container>
                      <Grid item xs={5} sx={{ pt: 1 }}>
                        <HeaderLabelTitle title="Late Fee" />
                      </Grid>
                      <Grid item xs={5}>
                        {/* <TextField
                        id="late_fee"
                        name="late_fee"
                        value={lateFee}
                        variant="outlined"
                        InputProps={{ readOnly: true }}
                        sx={{
                          background: "#e5e5e5",
                          "& input": { pl: "14px", pt: "5px" },
                        }}
                        onChange={(e) => {
                          handleInputChange(e);
                        }}
                      /> */}
                        {/* {lateFee}----{loan_saved_iLateFee}--- */}
                        <CustomControlMoneyEditTextField
                          name="late_fee"
                          // defaultValue={lateFee}
                          value={lateFee}
                          readonly={true}
                          onChange={handleInputChange}
                          required={true}
                          prefix={false}
                          helperText="no"
                          className="amountText"
                        />
                      </Grid>
                      <Grid item xs={2}></Grid>
                    </Grid>
                    {/* origination_fee_amount , TextField  */}
                    <Grid sx={{ mb: 2 }} container>
                      <Grid item xs={5} sx={{ pt: 1 }}>
                        <HeaderLabelTitle title="Origination Fee Amount" />
                      </Grid>
                      <Grid item xs={5}>
                        <CustomControlMoneyEditTextField
                          name="origination_fee_amount"
                          value={originationFeeAmount}
                          defaultValue={record?.origination_fee_amount}
                          readonly={true}
                          onChange={(
                            e: React.ChangeEvent<
                              HTMLInputElement | HTMLTextAreaElement
                            >
                          ) => {
                            handleInputChange(e);
                            if (
                              e.target.value != "0" &&
                              e.target.value != "0.00" &&
                              e.target.value != ""
                            ) {
                              setOriginationFeeTypeRequired(true);
                            } else {
                              setOriginationFeeTypeRequired(false);
                            }
                          }}
                          // required={true}
                          prefix={false}
                          helperText="no"
                          className="amountText"
                        />
                      </Grid>
                      <Grid item xs={2}></Grid>
                    </Grid>
                    {/* origination_fee_type, select optionlist Add to Loan Amount:Add to Loan Amount, Deduct from Funded Amount: Deduct from Funded Amount */}
                    <Grid sx={{ mb: 2 }} container>
                      <Grid item xs={5} sx={{ pt: 1 }}>
                        <HeaderLabelTitle
                          title="Origination Fee Type"
                          required={!!originationFeeTypeRequired}
                        />
                      </Grid>
                      <Grid item xs={5}>
                        <CustomSelect
                          fullWidth={true}
                          id="origination_fee_type"
                          name="origination_fee_type"
                          value={origination_fee_type}
                          optionlist={defautOriginationFeeTypeList}
                          variant="outlined"
                          // required={originationFeeTypeRequired}
                          required={!!originationFeeTypeRequired}
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            if (e.target.value != undefined) {
                              setOrigination_fee_type(e.target.value);
                            }
                            handleInputChange(e);
                          }}
                        />
                      </Grid>
                      <Grid item xs={2}></Grid>
                    </Grid>
                    {/* Day Count Convention:, default Actual/Actual */}
                    <Grid sx={{ mb: 2 }} container>
                      <Grid item xs={5} sx={{ pt: 1 }}>
                        <HeaderLabelTitle title="Day Count Convention" />
                      </Grid>
                      <Grid item xs={5}>
                        <TextField
                          id="sDayCountConvention"
                          name="sDayCountConvention"
                          value={record.sDayCountConvention}
                          variant="outlined"
                          InputProps={{ readOnly: true }}
                          sx={{
                            background: "#e5e5e5",
                            "& input": { pl: "14px", pt: "5px" },
                            borderRadius: "10px",
                          }}
                          onChange={(e) => {
                            handleInputChange(e);
                          }}
                        />
                      </Grid>
                      <Grid item xs={2}></Grid>
                    </Grid>
                    {/* Round Up Payments Except Last: YES */}
                    <Grid sx={{ mb: 2 }} container>
                      <Grid item xs={5} sx={{ pt: 1 }}>
                        <HeaderLabelTitle title="Round Up Payments Except Last" />
                      </Grid>
                      <Grid item xs={5}>
                        {/* <TextField
                      id="iPaymentRoundUp"
                      name="iPaymentRoundUp"
                      value="Yes"
                      variant="outlined"
                      InputProps={{ readOnly: true }}
                      sx={{
                        background: "#e5e5e5",
                        "& input": { pl: "14px", pt: "5px" },
                      }}
                      onChange={(e) => {
                        handleInputChange(e);
                      }}
                    /> */}
                        <CustomSelect
                          fullWidth={true}
                          id="iPaymentRoundUp"
                          name="iPaymentRoundUp"
                          optionlist={[
                            { label: "Yes", value: "YES" },
                            { label: "No", value: "NO" },
                          ]}
                          value={sPaymentRounding}
                          required={true}
                          variant="outlined"
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            if (e.target.value != undefined) {
                              setSPaymentRounding(e.target.value);
                            }
                            handleInputChange(e);
                          }}
                        />
                      </Grid>
                      <Grid item xs={2}></Grid>
                    </Grid>
                  </Grid>
                </CustomTabPanel>
                {/* end Approved Form */}
                {showDisbursementTab && (
                  <CustomTabPanel value={value} index={disbursementTabIndex}>
                    {/* Disbursement Form */}
                    <CustomToNotifyDisbursementDialog {...props} />
                  </CustomTabPanel>
                )}
                {showDepositAccountTab && (
                  <CustomTabPanel value={value} index={depositAccountTabIndex}>
                    {/* Deposit Institution Only section */}
                    <CustomToNotifyDepositDialog {...props} />
                  </CustomTabPanel>
                )}
                {showPurchaseDetailTab && (
                  <CustomTabPanel value={value} index={purchaseDetailTabIndex}>
                    {/* Purchase Detail section */}
                    <CustomToNotifyVendorDialog {...props} />
                  </CustomTabPanel>
                )}
                {showCollateralDetailTab && (
                  <CustomTabPanel
                    value={value}
                    index={collateralDetailTabIndex}
                  >
                    {/* Collateral Detail section */}
                    <CustomToNotifyCollateralDialog {...props} />
                  </CustomTabPanel>
                )}
              </Box>
            </>
          )}
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between" }}>
          {filePath ? (
            <>
              <CustomButtonCancel onClick={handleClose} />
              <Button
                label="Send"
                variant="contained"
                size="medium"
                sx={{ width: "120px", float: "right" }}
                disabled={isSubmitting || isPreviewLoading}
                onClick={() => handleApproveSend({ appId })}
              />
            </>
          ) : (
            <>
              <CustomButtonCancel onClick={handleClose} />
              {/* <Button
                onClick={() =>
                  downloadFileFun(
                    appId,
                    "approve_preview.pdf",
                    "execute2approve_preview",
                    ""
                  )
                }
                label="download"
              /> */}

              {value === 0 && (
                <>
                  {!isPreviewLoading && (
                    <Button
                      label={previewTitle}
                      endIcon={
                        isPreviewLoading ? (
                          <CircularProgress size={16} color="inherit" />
                        ) : null
                      }
                      variant="text"
                      size="medium"
                      color="warning"
                      sx={{ width: "120px" }}
                      onClick={(event) =>
                        handlePreviewApprove({ event, appId })
                      }
                      disabled={isPreviewLoading || isSubmitting}
                    />
                  )}
                  {isPreviewLoading && (
                    <Box sx={{ width: "260px", ml: 1 }}>
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{ display: "block", mb: 0.5 }}
                      >
                        {previewProgressLabel}
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                        }}
                      >
                        <LinearProgress
                          variant="determinate"
                          value={previewProgress}
                          sx={{
                            flex: 1,
                            height: 10,
                            borderRadius: 5,
                            backgroundColor: "#bbdefb",
                            "& .MuiLinearProgress-bar": {
                              backgroundColor: "#1976d2",
                            },
                          }}
                        />
                        <Typography
                          variant="caption"
                          sx={{ color: "#1565c0", minWidth: "40px" }}
                        >
                          {Math.round(previewProgress)}%
                        </Typography>
                      </Box>
                    </Box>
                  )}
                  <CustomButtonSubmit
                    label={submitTitle}
                    disabled={isPreviewLoading || isSubmitting}
                    color="success"
                  />
                </>
              )}
            </>
          )}
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
